module.exports = __webpack_public_path__ + "static/media/logo.773a6ad1.png";